import React, { useState} from "react";
import { useObjectStore } from "../zustand/objects";

import { ColorInput } from '@mantine/core';

const ModelColourButton = ({ colour, id, uiTheme }) => {

  const swatchColours = ['#000000', '#C4A484', '#00FFFF', '#359DED', '#77D356', '#C0C0C0', '#808080', '#FFA500', '#CD303E', '#FF00FF', '#FAC710', '#FFFFFF']

  const [colourSet, setColourSet] = useState(colour)
  const borderColour = uiTheme?.borderColour || "#E5E7EB";
  const iconColour = uiTheme?.iconColour || "#6A7282";
  const textColour = uiTheme?.textColour || "#111827";
  const placeholderColour = uiTheme?.placeholderColour || "#6A7282";


  const { arrangeUndoRedo, updateShapeColour, currentObjectArtboard } = useObjectStore();

  const handleSelect = (mapped) => {
     // send current state to undoActions
     mapped && arrangeUndoRedo({
      updateType: "objectUpdate", 
      artboard: currentObjectArtboard, 
      objectID: id,
      undo:false,
      field: "colour"
      })
      // send update to zustand
    mapped && updateShapeColour({
      id: id,
      currentObjectArtboard: currentObjectArtboard,
      colour: mapped,
      undo: false
    })
    setColourSet(mapped)
  }

  return (

    // <div style={{ inline: true, marginLeft:0, paddingLeft:0, height:28, marginTop:15, paddingTop:1, fontSize: 12, width:100,  display:'flex', transition: "width 0.2s", justifyContent: 'flex-start' }}>
      <ColorInput
      closeOnColorSwatchClick
      placeholder="Colour"
      defaultValue={colourSet}
      onChange={(e) => handleSelect(e)}
      label="Colour"
      size="sm"
      // radius={32}
      disallowInput
      withPicker={true}
      withEyeDropper={true}
      swatches={[...swatchColours]}
      swatchesPerRow={6}
      styles={{
        label: { color: textColour, fontWeight: 600 },
        input: {
          color: textColour,
          borderColor: borderColour,
          "&:focus": { borderColor: borderColour },
          "&:focus-within": { borderColor: borderColour },
        },
        section: { color: iconColour },
        placeholder: { color: placeholderColour },
      }}
    />
    // </div>


  );
};

export default ModelColourButton;











